import React from 'react';
import { CyberBackground, NeonText } from '../components/CyberEffects';
import './LegalPage.css';

function Terms({ navigate }) {
  return (
    <div className="legal-container animate-fade-in">
      <CyberBackground showParticles={false} />

      <div className="legal-content">
        <button className="back-btn" onClick={() => navigate('home')}>
          ← 戻る
        </button>

        <h1 className="legal-title">
          <NeonText color="accent" size="lg">利用規約</NeonText>
        </h1>

        <div className="legal-body">
          <div className="legal-section">
            <h2>第1条（適用）</h2>
            <p>
              本規約は、株式会社Eight Goodが運営するクイズ ワン ワード（以下「本サービス」）の
              利用に関する条件を、本サービスを利用するすべてのユーザー（以下「ユーザー」）と
              運営者との間で定めるものです。
            </p>
          </div>

          <div className="legal-section">
            <h2>第2条（サービス内容）</h2>
            <p>
              本サービスは、複数人で協力してプレイするクイズゲームを提供します。
              サービスの具体的な内容は、運営者が定め、随時変更できるものとします。
            </p>
          </div>

          <div className="legal-section">
            <h2>第3条（利用登録）</h2>
            <ul>
              <li>本サービスは、匿名でも利用可能です。</li>
              <li>有料機能の利用には、メールアドレスによるアカウント登録が必要です。</li>
              <li>登録情報に虚偽があった場合、サービスの利用を停止することがあります。</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>第4条（禁止事項）</h2>
            <p>ユーザーは、以下の行為を行ってはなりません。</p>
            <ul>
              <li>法令または公序良俗に違反する行為</li>
              <li>犯罪行為に関連する行為</li>
              <li>サービスの運営を妨害する行為</li>
              <li>他のユーザーに迷惑をかける行為</li>
              <li>不正アクセスやチート行為</li>
              <li>本サービスのデータを不正に取得・利用する行為</li>
              <li>運営者や他のユーザーを誹謗中傷する行為</li>
              <li>その他、運営者が不適切と判断する行為</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>第5条（有料サービス）</h2>
            <ul>
              <li>有料サービスの料金は、別途定める料金表に従います。</li>
              <li>支払いはクレジットカード（Stripe経由）で行われます。</li>
              <li>サブスクリプションは、解約手続きをしない限り自動更新されます。</li>
              <li>デジタルコンテンツの性質上、購入後の返金は原則として行いません。</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>第6条（知的財産権）</h2>
            <p>
              本サービスに関する著作権、商標権その他の知的財産権は、
              運営者または正当な権利者に帰属します。
              ユーザーは、これらの権利を侵害してはなりません。
            </p>
          </div>

          <div className="legal-section">
            <h2>第7条（第三者との関係）</h2>
            <p>
              本サービスは、フジテレビジョン「ネプリーグ」およびその関連会社とは
              一切関係のない、独立したサービスです。
              本サービスに関するお問い合わせを、これらの第三者に行わないでください。
            </p>
          </div>

          <div className="legal-section">
            <h2>第8条（免責事項）</h2>
            <ul>
              <li>本サービスは「現状のまま」提供され、特定目的への適合性を保証しません。</li>
              <li>サービスの中断、停止、終了により生じた損害について、運営者は責任を負いません。</li>
              <li>ユーザー間のトラブルについて、運営者は責任を負いません。</li>
              <li>通信環境や端末の問題により生じた損害について、運営者は責任を負いません。</li>
            </ul>
          </div>

          <div className="legal-section">
            <h2>第9条（サービスの変更・終了）</h2>
            <p>
              運営者は、ユーザーへの事前の通知なく、本サービスの内容を変更し、
              または提供を終了することができます。
              サービス終了の際は、合理的な期間をもって事前に告知するよう努めます。
            </p>
          </div>

          <div className="legal-section">
            <h2>第10条（利用停止）</h2>
            <p>
              運営者は、ユーザーが本規約に違反した場合、事前の通知なく
              当該ユーザーの利用を停止することができます。
            </p>
          </div>

          <div className="legal-section">
            <h2>第11条（規約の変更）</h2>
            <p>
              運営者は、必要と判断した場合、本規約を変更することができます。
              変更後の規約は、本サービス上に掲示した時点で効力を生じます。
            </p>
          </div>

          <div className="legal-section">
            <h2>第12条（準拠法・裁判管轄）</h2>
            <p>
              本規約の解釈には日本法を適用します。
              本サービスに関する紛争については、運営者の所在地を管轄する裁判所を
              第一審の専属的合意管轄裁判所とします。
            </p>
          </div>
        </div>

        <p className="legal-date">最終更新日: 2026年1月23日</p>
      </div>
    </div>
  );
}

export default Terms;
